import React, { useState, useEffect } from "react";
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from "primereact/inputtext";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';


export const ChannelMasterForm = () => {
    const [showStatusForm, setShowStatusForm] = useState(false);
    const [data, setData] = useState([]);

    // select field
  const [selectedChannel, setSelectedChannel] = useState(null);
  const channel = [
    { name: 'Active', value: 1 },
    { name: 'In-Active', value: 2 },
    { name: 'Archive', value: 3 },
    { name: 'Reject', value: 4 },
    
];

    const data1 = [
        {
            statusNo: 1,
            statusName: 'Home Insurance',
            status: 1,
        },
        {
            statusNo: 2,
            statusName: 'Home Insurance',
            status: 2,
        },
        {
            statusNo: 3,
            statusName: 'Home Insurance',
            status: 3,
        }

    ]

    const formDialog = () => {
        setShowStatusForm(true);
    };
    useEffect(() => {
        setData(data1);
    }, []);
    const ActionBodyTemplate = (rowData, rowIndex) => {
        return (
            <React.Fragment>
                <Button icon="pi pi-trash" className="p-button-rounded p-button-danger mr-2" tooltip="Delete Chennel" tooltipOptions={{ position: "top" }} />
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-secondary mr-2" tooltip="Edit Chennel" tooltipOptions={{ position: "top" }} onClick={() => { setEdit(true) }}></Button>
            </React.Fragment>
        );
    };
    return (
        <div>
            <h3>Channel Master</h3>
            <Button className="pi pi-plus" onClick={() => formDialog()} >Create Chennel</Button>
            <Dialog visible={showStatusForm} onHide={() => setShowStatusForm(false)}>

                <form className="p-fluid p-grid">
                    <div className="p-field col-6">
                        <label htmlFor="username">Channel Name</label>
                        <InputText id="username" aria-describedby="username-help" />
                        <label htmlFor="date"> Channel type</label>
                        <span>
                        <Dropdown
                                name="status"
                                value={selectedChannel}
                                onChange={(e) => setSelectedChannel(e.value)}
                                options={channel}
                                optionLabel="name"
                                placeholder="Select channel type" />
                        </span>
                    </div>

                </form>

                <div style={{ float: 'right' }}>
                    <Button
                        type="button"
                        label="Cancel"
                        className="p-button-rounded p-default"
                        onClick={() => setShowStatusForm(false)}
                    />
                    <Button
                        type="submit"
                        label="Submit"
                        className="p-button-rounded"
                    />
                </div>
            </Dialog>
            <DataTable value={data}>
                <Column field="statusNo" header="S.NO"></Column >
                <Column field="statusName" header="Channel Name"></Column >
                <Column field="status" header="Channel Type"></Column >
                <Column header="Action" body={ActionBodyTemplate}></Column >
            </DataTable>
        </div>
    );
}
